import React, { useEffect, useState } from "react";
import axiosInstance from "../hook/axiosInstance";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Box, Typography } from "@mui/material";
import { TextEditor } from "../components/text-editor";
import * as Yup from "yup";
import axiosInstanceWithUrlencoded from "../hook/urlencoded";
import { toast } from "react-toastify";

const HistoryPage = () => {
  const [initialData, setInitialData] = useState();

  const initialValues = {
    content: "",
    created_by: 1,
  };

  const validationSchema = Yup.object().shape({
    content: Yup.string().required("Content is required"),
  });

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get("history-get");
      const profileData = response.data;
      setInitialData(profileData.data[0]);
    } catch (error) {
      console.error("Error fetching company profile data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const notify = (msg) => {
    toast.success(msg);
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const formData = new URLSearchParams(); // Using URLSearchParams for URL-encoded form data
      const test = { created_by: 1 };

      const data = { ...values, ...test };

      // Append each key-value pair to the URLSearchParams object
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value);
      });

      let response;
      // if (initialData && initialData.id) {
      //   response = await axiosInstanceWithUrlencoded.put(
      //     `/history/update/${initialData.id}`,
      //     formData, // Sending URL-encoded form data
      //   );
      // } else {
      response = await axiosInstanceWithUrlencoded.post(
        "/history-save",
        formData
      );
      // }

      if (response) {
        notify("History saved data successfully ");
        fetchData();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const handleSubmit = async (values, { resetForm }) => {
  //   try {
  //     const formData = new FormData();
  //     const test = { created_by: Date.now() };

  //     const data = { ...values, ...test };
  //     // Append each key-value pair to the FormData object
  //     Object.entries(data).forEach(([key, value]) => {
  //       formData.append(key, value);
  //     });
  //     let response;
  //     if (initialData && initialData?.id) {
  //       response = await axiosInstance.put(
  //         `/history/update/${initialData?.id}`,
  //         data,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data", // Ensure correct content type
  //           },
  //         }
  //       );
  //     } else {
  //       response = await axiosInstance.post("/history/save", data, {
  //         headers: {
  //           "Content-Type": "multipart/form-data", // Ensure correct content type
  //         },
  //       });
  //     }
  //     if (response) {
  //       fetchData();
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  return (
    <div
      id="kt_app_content"
      className="app-content flex-column-fluid"
      style={{ overflowY: "scroll" }}
    >
      <div
        id="kt_app_content_container"
        className="app-container container-xxl"
        style={{ overflowY: "scroll" }}
      >
        <div className="row gx-5 gx-xl-12 pt-10">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body py-4">
                <Formik
                  initialValues={
                    initialData && initialData?.id ? initialData : initialValues
                  }
                  enableReinitialize={true}
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                >
                  {({ setFieldValue, values }) => {
                    return (
                      <Form
                        id="kt_ecommerce_settings_general_form"
                        className="form"
                      >
                        <Box>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            History Content
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="content"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red">
                              <ErrorMessage name="content" />
                            </Box>
                          </Box>
                        </Box>

                        <Box mt={10}>
                          <div className="col-md-12 mt-25">
                            <button
                              type="submit"
                              className="btn btn-primary me-3"
                            >
                              <span className="indicator-label">Save</span>
                            </button>

                            <button type="reset" className="btn btn-light me-3">
                              Cancel
                            </button>
                          </div>
                        </Box>
                        {/* </div> */}
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
};

export default HistoryPage;
